import {unref} from 'vue'
import {IDatabasePropertyResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {IDatabaseItemResponseInstance} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'
import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {DatabaseViewType} from '@toolify/server/src/models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
import {DateGroupGranularityType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/enum/DateGroupGranularityType'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {GroupSortModeType} from '@toolify/server/src/services/DatabasePropertyService/enum/GroupSortModeType'
import {COMMON_GROUP_SORT_LABEL_KEYS} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {
  usePeopleValueTypeStrategy,
} from '@toolify/client/src/modules/databases/strategies/PropertyValueTypeStrategy/composables/usePeopleValueTypeStrategy'

type WatchersFullValue = IResponseEntity[] | null

export function useWatchersValueTypeStrategy() {
  const peopleValueTypeStrategy = usePeopleValueTypeStrategy()
  const strategyComponentType = PropertyStrategyComponentType.Other

  const canGroupByView = (viewType: DatabaseViewType, _property: IDatabasePropertyResponseInstance) =>
    viewType === DatabaseViewType.Table || viewType === DatabaseViewType.Kanban

  const canMoveItemToAnotherGroup = (_property: IDatabasePropertyResponseInstance | null | undefined, _granularity?: DateGroupGranularityType | null): boolean => false

  const socketCellValueToClientCellValue = (
    _previousValue: IDatabaseItemResponseInstance['cellValues'][string],
    newValue: IDatabaseItemResponseInstance['cellValues'][string],
  ): IDatabaseItemResponseInstance['cellValues'][string] => ({
    ...newValue,
    valueType: newValue?.valueType ?? PropertyValueType.Watchers,
  })

  const compareItemValues = (
    valueA: WatchersFullValue,
    valueB: WatchersFullValue,
    sortDirection: '1' | '-1',
  ): number => {
    const lengthA = Array.isArray(valueA) ? valueA.length : 0
    const lengthB = Array.isArray(valueB) ? valueB.length : 0
    if(!lengthA && !lengthB) return 0
    if(!lengthA) return 1
    if(!lengthB) return -1
    const comparison = lengthA - lengthB
    return sortDirection === '1' ? comparison : -comparison
  }

  const groupSort = {
    availableModes: [
      GroupSortModeType.ValueAsc,
      GroupSortModeType.ValueDesc,
      GroupSortModeType.CountDesc,
      GroupSortModeType.CountAsc,
    ],
    defaultMode: GroupSortModeType.ValueAsc,
    getLabelKey: (mode: GroupSortModeType): string => COMMON_GROUP_SORT_LABEL_KEYS[mode],
    compareGroupValues: (
      valueA: WatchersFullValue,
      valueB: WatchersFullValue,
      sortDirection: '1' | '-1',
    ): number => unref(peopleValueTypeStrategy.compareItemValues)(valueA, valueB, sortDirection),
  }

  return {
    ...peopleValueTypeStrategy,
    strategyComponentType,
    canGroupByView,
    canMoveItemToAnotherGroup,
    socketCellValueToClientCellValue,
    compareItemValues,
    groupSort,
    searchToFilterQuery: undefined,
  }
}
